module.exports = __webpack_public_path__ + "media/images/photo/plans/shooting-spots/shooting-spot-kanto-2-aabc22150f811cd5debeb48412eff6a8.png";